import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent {
  showError: boolean = false;
  errorMessage!: string;
  isLoader: boolean = false;
  emailInvalid!: boolean;
  user: any;
  @Input() id?: string;

  constructor(
    private _authService: AuthService,
    private _cookies: CookieService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {
    this.user = {
      login: '',
      password: '',
      stayLogged: false,
    };
  }

  inscription(user: any, isMobile: boolean, isInvalid?: any) {}

}
